// ESL Web Demo - App Shell (Clerk-only)
//
// Renders Clerk sign-in when signed out, and the legacy UI (CoreApp) when signed in.

import React, { useCallback } from 'react';
import CoreApp from './CoreApp';
import './App.css';

import { SignedIn, SignedOut, SignIn, useAuth, useClerk } from '@clerk/clerk-react';

function FullScreenCenter({ children }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        boxSizing: 'border-box',
      }}
    >
      {children}
    </div>
  );
}

export default function App() {
  const { isLoaded, getToken } = useAuth();
  const { signOut } = useClerk();

  const getAuthToken = useCallback(async () => {
    const token = await getToken();
    if (!token) throw new Error('No Clerk token available.');
    return token;
  }, [getToken]);

  const handleLogout = useCallback(() => {
    try {
      signOut();
    } catch (e) {
      console.warn('Clerk signOut failed:', e);
    }
  }, [signOut]);

  if (!isLoaded) {
    return (
      <FullScreenCenter>
        <div style={{ fontSize: '1.2rem' }}>Loading...</div>
      </FullScreenCenter>
    );
  }

  return (
    <>
      <SignedOut>
        <FullScreenCenter>
          <SignIn />
        </FullScreenCenter>
      </SignedOut>

      <SignedIn>
        <CoreApp getAuthToken={getAuthToken} onLogout={handleLogout} />
      </SignedIn>
    </>
  );
}
